(function () {
  'use strict';

  // Currently this component is being used only for affiliate user role
  // Please check before reusing this someplace else
  angular.module('ringbaPortal').component('addNumberForm', {
    bindings: {
      isAffiliateManager: '<',
      existingNumber: '<',
      currentCampaign: '<',
      campaignCountry: '<',
      isEnrolledInOffer: '<',
      numberRestrictions: '<',
      onDismiss: '&',
      onSave: '&'
    },
    controller: AddNumberFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/publisher-campaign-numbers/add-number-form/add-number-form.view.html'
  });

  function AddNumberFormController(
    $filter,
    accountsService,
    bsLoadingOverlayService,
    campaignAffiliateService,
    infoService,
    numberService,
    offersService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;
    const loaderRefId = 'checkingExistingNumbers';
    let hasNumberCreationPermission;

    vm.assignmentSettings = {
      chargeAccountIfNeeded: false
    };

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.selectAffiliate = selectAffiliate;
    vm.handleSubmit = handleSubmit;
    vm.cancelAddNew = cancelAddNew;

    function onInit() {
      vm.isAffiliate = accountsService.isAffiliate();

      if (vm.isAffiliate) {
        vm.assignmentSettings.chargeAccountIfNeeded = true;
      }

      if (!vm.isAffiliate || (vm.isAffiliate && !vm.isEnrolledInOffer)) {
        _loadAvailableNumbers();
      }

      hasNumberCreationPermission = accountsService.hasAccess('Number', 'CREATE');

      _showCreateNewOrExistingForm();

    }

    function onChanges(changesObj) {
      if (changesObj.currentCampaign && vm.currentCampaign && vm.currentCampaign.affiliates) {
        vm.selectedAffiliate = vm.isAffiliateManager ? null : vm.currentCampaign.affiliates[0];

        if (vm.isAffiliateManager) {
          vm.managedAffiliates = vm.currentCampaign.affiliates || [];
        }
      }

      _loadAvailableNumbers();
      _loadCampaignCountry();
    }

    function selectAffiliate(affiliate) {
      if (!affiliate) {
        return;
      }

      _loadAvailableNumbers();
    }

    function handleSubmit() {
      const numberObj = {
        campaign: {
          id: vm.currentCampaign.id,
          countryCode: vm.campaignCountry
        },
        affiliateId: vm.selectedAffiliate.id,
        numbersToAdd: vm.numbersToAdd,
        createNewNumber: vm.createNewNumber,
        assignmentSettings: vm.assignmentSettings
      };

      if (!vm.isEnrolledInOffer) {
        return _addNumberToCampaignAffiliate(numberObj);
      } else {
        return _addNumberToOfferAffiliate(numberObj);
      }
    }

    function cancelAddNew() {
      vm.onDismiss({
        number: vm.existingNumber
      });
    }

    function _addNumberToCampaignAffiliate(number) {
      return campaignAffiliateService.addAffiliateWithNumbers(accountsService.currentAccountId, number).then(function () {
        _handleAddNumberToAffiliate();
      }).catch(utils.errorHandler);
    }

    function _addNumberToOfferAffiliate(number) {
      return offersService.addCampaignOfferPublisherNumbers(accountsService.currentAccountId, vm.currentCampaign.id, number).then(function () {
        _handleAddNumberToOfferAffiliate();
      }).catch(utils.errorHandler);
    }

    function _handleAddNumberToOfferAffiliate() {
      toaster.pop('success', $filter('translate')('ADD_AFFILIATE_NUMBERS_ADDED_TO_OFFER'));
      vm.onSave({
        number: vm.existingNumber
      });
    }

    function _handleAddNumberToAffiliate() {
      toaster.pop('success', $filter('translate')('ADD_AFFILIATE_NUMBERS_ADDED_TO_PUBLISHER'));
      vm.onSave({
        number: vm.existingNumber
      });
    }

    function _loadAvailableNumbers() {
      if (vm.allNumbers) {
        _filterNumbers(vm.allNumbers);
      } else if(vm.checkingExistingNumbers) {
        return;
      } else {
        _showCheckNumbersLoader();
        return numberService.getNumbers(accountsService.currentAccountId)
          .then(function (response) {
            vm.allNumbers = response.data.numbers;
            _filterNumbers(vm.allNumbers);
            _hideCheckNumbersLoader();
          })
          .catch(utils.errorHandler);
      }
    }

    function _loadCampaignCountry() {
      infoService.getCountriesWithAddressCheck()
        .then(function (response) {
          // TODO: Guard against campaignCountry not set
          vm.campaignCountryWithAddressCheck = _.find(response.data, function (o) {
            return o.countryCode === vm.campaignCountry;
          });

          // This checks for address requirement of both local and toll free numbers
          vm.addressRequirementFulfilled =
            (vm.campaignCountryWithAddressCheck && vm.campaignCountryWithAddressCheck.hasLocalNumbers && vm.campaignCountryWithAddressCheck.addressRequirementFullfilledForLocalNumbers)
            ||
            (vm.campaignCountryWithAddressCheck && vm.campaignCountryWithAddressCheck.hasTollFreeNumbers && vm.campaignCountryWithAddressCheck.addressRequirementFullfilledForTollFreeNumbers);
        })
        .catch(utils.errorHandler);
    }

    function _showCheckNumbersLoader() {
      vm.checkingExistingNumbers = true;
      bsLoadingOverlayService.start({
        referenceId: loaderRefId
      });
    }

    function _hideCheckNumbersLoader() {
      vm.checkingExistingNumbers = false;
      bsLoadingOverlayService.stop({
        referenceId: loaderRefId
      });
    }

    // TODO: Move identical logic to service
    function _filterNumbers(allNumbers) {
      if (vm.selectedAffiliate) {
        vm.numbers = _.filter(allNumbers, function checkIfNumberIsEligibleToCampaign(number) {
          return numberService.isNumberEligibleForCampaignOrOffer(number, vm.campaignCountry, vm.selectedAffiliate);
        });

        _showCreateNewOrExistingForm();
      }
    }

    // For publishers that are participating in an offer, only allow them to create new numbers, for now
    function _showCreateNewOrExistingForm() {
      if (!vm.isEnrolledInOffer && vm.numbers) {
        vm.noExistingNumber = !vm.numbers.length;
      } else {
        vm.noExistingNumber = true;
      }

      if (vm.isAffiliateManager) {
        vm.canCreateNumbersForSelectedAffiliate = vm.selectedAffiliate && vm.selectedAffiliate.createNumbers;
        vm.createNewNumber = vm.canCreateNumbersForSelectedAffiliate && vm.noExistingNumber;
        return;
      }

      vm.createNewNumber = !hasNumberCreationPermission || (hasNumberCreationPermission && vm.noExistingNumber);
    }
  }
})();
